define('presentation/signup/viewModels/signupPhoneNumberPortAuthorizationViewModel',[
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'common/storage/workSessionIdStorage',
    'presentation/signup/common/signupNavigationManager',
    'presentation/signup/facades/signupPhoneNumberPortFacade',
    'presentation/signup/validators/signupPhoneNumberPortAuthorizationValidator'
], function() {

    return function() {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _i18n = require('i18next');
        const _workSessionIdStorage = require('common/storage/workSessionIdStorage');

        let _disposables = [];
        let _facade = null;
        let _signupNavigationManager = null;
        let _validator = null;

        const _isSignupForCustomer = _workSessionIdStorage.getWorkSessionId() !== null && _workSessionIdStorage.getWorkSessionId() !== undefined;

        self.headingText = _i18n.t('signupPhoneNumberPortAuthorization:headingText');
        self.subtitleText = _i18n.t('signupPhoneNumberPortAuthorization:subtitleText');

        self.authorizedSignature = ko.observable("");
        self.isAcknowledged = ko.observable(false);
        self.isSignupForCustomer = ko.observable(_isSignupForCustomer);
        self.isCompositionComplete = ko.observable(false);
        self.isScrollActive = ko.observable(false);
        self.isValid = ko.observable(false);
        self.portDate = ko.observable("");
        self.portDateSelection = ko.observable("default");
        self.showValidation = ko.observable(false);

        self.customerAgreesToStatement = ko.pureComputed(() => {
            if (self.showValidation()) {
                return self.isAcknowledged();
            }
            return true;
        });

        self.isNavigateToNextPageActive = ko.computed(() => self.isValid() && self.isAcknowledged());

        const _onPortDateChange = () => {
            if (self.portDate().length > 0) {
                _facade.saveNumberPortDesiredPortDate(self.portDate());
            }
        };

        self.onBackArrowClicked = () => {
            return _promiseFactory.defer((deferredObject) => {
                _facade.resetNumberTypeSelection()
                    .fail(deferredObject.reject)
                    .done(() => {
                        deferredObject.resolve();
                        _signupNavigationManager.previousPage();
                    });
            });
        };

        self.onForwardArrowClicked = () => {
            return _promiseFactory.defer((deferredObject) => {
                _validator.validate()
                    .fail(deferredObject.reject)
                    .done((isValid) => {
                        self.showValidation(true);
                        if (!isValid) {
                            deferredObject.resolve(false);
                        } else {
                            _facade.storeNumberPortAuthorizedSignature(self.authorizedSignature());
                            _facade.storeNumberPortIsAcknowledged(self.isAcknowledged());
                            _facade.setPhoneNumberCompleted(true)
                                .fail(deferredObject.reject)
                                .done(() => deferredObject.resolve(true));
                        }
                    });
            });
        };

        self.toggleAcknowledgement = () => {
            self.isAcknowledged(!self.isAcknowledged());
        };

        self.detached = () => {
            _signupNavigationManager.detached();
            _disposables.forEach(subscription => subscription.dispose);
            _disposables = [];
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/signup/facades/signupPhoneNumberPortFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
            _signupNavigationManager = new SignupNavigationManagerConstructor();
            _signupNavigationManager.init();

            const ValidatorConstructor = require('presentation/signup/validators/signupPhoneNumberPortAuthorizationValidator');
            _validator = new ValidatorConstructor();

            return _initialize();
        };

        const _initialize = () => {
            _promiseFactory.deferIndefinitely((initializeDeferredObject) => {
                _facade.loadSignupSession()
                    .done((signupSession) => {
                        // self.isAcknowledged(signupSession.isAcknowledged);
                        // self.authorizedSignature(signupSession.authorizedSignature);

                        // Registered before the prefill so prefilled values validate and
                        // reach the isValid group the forward arrow reads.
                        _validator.registerViewModel(self, _facade);

                        if (signupSession.portDate) {
                            const date = new Date(signupSession.portDate);
                            date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
                            self.portDate(date.toISOString());
                        }
                        _disposables.push(self.portDate.subscribe(_onPortDateChange));

                        initializeDeferredObject.resolve();
                    });
            });

            return _promiseFactory.wait();
        };
    };
});
